export default {
  BY_PIM_ID: 'byPimId',
  BRAND: 'brand',
  BRAND_NAME: 'brandName',
  PIM_BRAND_NAME: 'pimBrandName',
  LOGO_URL: 'logoUrl',
  LOGO_DATA: 'logoData',
  LOGO_PROMISE: 'logoPromise',
  LOGO_VIEWBOX: 'logoViewbox',
  ID: 'id',
}
